const translations: Record<string, string> = {
  action_save: 'Zapisz',
  action_saving: 'Zapisywanie...',
  // Greeting
  greeting_morning: 'Dzień dobry',
  greeting_day: 'Dzień dobry',
  greeting_evening: 'Dobry wieczór',

  // Nav sections
  nav_cabinet: 'Panel',
  nav_operations: 'Operacje',
  nav_system: 'System',
  nav_platform_admin: 'Admin Platformy',
  nav_administration: 'Administracja',

  // Nav items
  nav_dashboard: 'Pulpit',
  nav_home: 'Strona główna',
  nav_dispatch_room: 'Dyspozytornia',
  nav_contacts: 'Kontakty',
  nav_info: 'Info',
  nav_owner_dashboard: 'Dashboard właściciela',
  nav_platform_dashboard: 'Dashboard',
  nav_platform_tenants: 'Przegląd tenantów',
  nav_platform_users: 'Przegląd użytkowników',
  nav_platform_counterparties: 'Przegląd kontrahentów',
  nav_platform_assets: 'Przegląd aktywów',
  nav_onboarding: 'Onboarding',
  nav_counterparties: 'Kontrahenci',
  nav_assets: 'Aktywa',
  nav_contracts: 'Kontrakty',
  nav_documents: 'Dokumenty',
  nav_forecast: 'Prognoza',
  nav_bess: 'BESS',
  nav_comdisp: 'Dyspozytornia handlowa',
  nav_monitor: 'Monitor',
  nav_settings: 'Ustawienia',
  nav_tenants: 'Tenants',
  nav_tenant_users: 'Użytkownicy tenantów',
  nav_roles: 'Role',

  // Topbar
  topbar_search: 'Szukaj...',
  topbar_notifications: 'Powiadomienia',
  topbar_add_station: 'Dodaj stację',
  topbar_profile: 'Profil',
  topbar_settings: 'Ustawienia',
  topbar_company: 'Firma',
  topbar_team: 'Zespół',
  topbar_logout: 'Wyloguj się',

  // Home page
  home_breadcrumb_home: 'Strona główna',
  home_breadcrumb_dashboard: 'Pulpit',
  home_export: 'Eksport',
  home_submit_mms: 'Wyślij MMS',
  home_hourly_chart: 'Godzinowy wykres produkcji',
  home_vs_yesterday: '↑ 12% vs wczoraj',
  home_col_hour: 'Godzina',
  home_col_forecast: 'Prognoza',
  home_col_fact: 'Fakt',
  home_col_deviation: 'Odchylenie',
  home_col_price: 'Cena DAM',
  home_col_revenue: 'Przychód',

  // Notifications
  notif_inverter_alarm: 'Inwerter #3 — alarm',
  notif_mms_confirmed: 'Raport MMS potwierdzony',
  notif_market_digest: 'Nowy digest rynkowy',
  notif_2h: '2 godz.',
  notif_yesterday: 'wczoraj',

  // User menu
  user_guest: 'Gość',

  // Assets page
  assets_title: 'Aktywa',
  assets_subtitle: 'Zarządzanie aktywami energetycznymi',
  assets_search: 'Szukaj po nazwie lub kodzie EIC...',
  assets_all_types: 'Wszystkie typy',
  assets_loading: 'Ładowanie aktywów...',
  assets_not_found: 'Nie znaleziono aktywów',
  assets_not_found_hint: 'Aktywa są tworzone z profilu kontrahenta',
  assets_filter_hint: 'Spróbuj zmienić filtry',
  assets_col_asset: 'Aktywo',
  assets_col_eic: 'Kod EIC',
  assets_col_type: 'Typ',
  assets_col_capacity: 'Moc',
  assets_col_region: 'Region',
  assets_col_status: 'Status',
  assets_col_counterparty: 'Kontrahent',
  asset_type_solar: 'Słoneczna',
  asset_type_wind: 'Wiatrowa',
  asset_type_bess: 'Magazyn energii',
  asset_type_hybrid: 'Hybrydowa',
  asset_type_consumer_site: 'Obiekt odbiorczy',
  asset_status_active: 'Aktywna',
  asset_status_planned: 'Planowana',
  asset_status_construction: 'Budowa',
  asset_status_commissioning: 'Rozruch',
  asset_status_suspended: 'Wstrzymana',
  asset_status_decommissioned: 'Wycofana',

  // Contracts page
  contracts_title: 'Kontrakty',
  contracts_subtitle: 'Zarządzanie umowami PPA, dostawczymi i serwisowymi',
  contracts_search: 'Szukaj po numerze lub kontrahencie...',
  contracts_loading: 'Ładowanie kontraktów...',
  contracts_not_found: 'Nie znaleziono kontraktów',
  contracts_not_found_hint: 'Kontrakty są tworzone z profilu aktywa',
  contracts_filter_hint: 'Spróbuj inne zapytanie',
  contracts_col_number: 'Numer',
  contracts_col_type: 'Typ',
  contracts_col_counterparty: 'Kontrahent',
  contracts_col_asset: 'Aktywo',
  contracts_col_period: 'Okres',
  contracts_col_status: 'Status',
  contract_status_active: 'Aktywna',
  contract_status_draft: 'Wersja robocza',
  contract_status_pending: 'W uzgodnieniu',
  contract_status_expired: 'Wygasła',
  contract_status_terminated: 'Rozwiązana',

  // Documents page
  documents_title: 'Dokumenty',
  documents_subtitle: 'Zarządzanie metadanymi dokumentów i weryfikacja',
  documents_search: 'Szukaj po nazwie pliku lub kontrahencie...',
  documents_loading: 'Ładowanie dokumentów...',
  documents_not_found: 'Nie znaleziono dokumentów',
  documents_not_found_hint: 'Dokumenty są dodawane z profilów aktywów lub kontrahentów',
  documents_filter_hint: 'Spróbuj inne zapytanie',
  documents_col_file: 'Plik',
  documents_col_type: 'Typ',
  documents_col_counterparty: 'Kontrahent',
  documents_col_asset_contract: 'Aktywo / Kontrakt',
  documents_col_status: 'Status',
  documents_col_uploaded: 'Przesłano',
  documents_col_by: 'Przez',

  // Forecast page
  forecast_title: 'Prognoza',
  forecast_subtitle: 'Prognozowanie generacji · Model ML v0.2.2',
  forecast_export: 'Eksport XLSX',
  forecast_weather_title: 'Pogoda / Bołhrad',
  forecast_weather_partly_cloudy: 'Mało chmurnie',
  forecast_weather_insolation: 'Nasłonecznienie',
  forecast_weather_clouds: 'Zachmurzenie',
  forecast_weather_wind: 'Wiatr',
  forecast_weather_humidity: 'Wilgotność',
  forecast_model_title: 'Model ML',
  forecast_model_version: 'Wersja',
  forecast_model_updated: 'Zaktualizowano',
  forecast_model_horizon: 'Horyzont',
  forecast_model_training: 'Trening',
  forecast_model_mape: 'MAPE (7 dni)',
  forecast_accuracy: 'Dokładność prognozy',
  forecast_accuracy_period: 'za ostatnie 30 dni',

  // Counterparties page
  cp_title: 'Kontrahenci',
  cp_subtitle: 'Zarządzaj kontrahentami i partnerami biznesowymi',
  cp_new: 'Nowy kontrahent',
  cp_search: 'Szukaj po nazwie lub EDRPOU...',
  cp_loading: 'Ładowanie kontrahentów...',
  cp_not_found: 'Nie znaleziono kontrahentów',
  cp_not_found_hint: 'Utwórz pierwszego kontrahenta, aby zacząć',
  cp_filter_hint: 'Spróbuj innego zapytania',
  cp_start_onboarding: 'Rozpocznij onboarding',
  cp_col_name: 'Nazwa',
  cp_col_edrpou: 'EDRPOU',
  cp_col_country: 'Kraj',
  cp_col_status: 'Status',
  cp_col_onboarding: 'Onboarding',
  cp_col_assets: 'Aktywa',
  cp_col_created: 'Utworzono',

  // Onboarding page
  ob_title: 'Onboarding kontrahenta',
  ob_subtitle: 'Wypełnij 5-krokowy formularz, aby zarejestrować organizację w systemie Helios.',
  ob_step_company: 'Firma',
  ob_step_legal: 'Prawne',
  ob_step_contact: 'Kontakt',
  ob_step_bank: 'Bank',
  ob_step_roles: 'Role',
  ob_back: 'Wstecz',
  ob_next: 'Dalej',
  ob_submit: 'Wyślij',
  ob_submitting: 'Wysyłanie...',
  ob_success_title: 'Onboarding wysłany',
  ob_success_text: 'Kontrahent został utworzony i oczekuje na weryfikację. ID:',
  ob_complete: 'Zakończ onboarding',
  ob_completing: 'Kończenie...',
  ob_go_to_profile: 'Przejdź do profilu',
  ob_fill_required: 'Wypełnij wszystkie wymagane pola',
  ob_select_role: 'Wybierz co najmniej jedną rolę',

  // Onboarding Step 1 — Company Identity
  ob_s1_title: 'Identyfikacja firmy',
  ob_s1_subtitle: 'Wprowadź podstawowe dane identyfikacyjne swojej firmy.',
  ob_s1_name: 'Nazwa firmy',
  ob_s1_name_ph: 'np. Helios Energy Sp. z o.o.',
  ob_s1_shortName: 'Nazwa skrócona',
  ob_s1_shortName_ph: 'np. Helios',
  ob_s1_edrpou: 'Kod EDRPOU',
  ob_s1_edrpou_ph: '8-cyfrowy kod',
  ob_s1_taxId: 'NIP',
  ob_s1_taxId_ph: 'Numer identyfikacji podatkowej',
  ob_s1_country: 'Kraj',
  ob_s1_country_ph: 'np. Ukraina',

  // Onboarding Step 2 — Legal Profile
  ob_s2_title: 'Profil prawny',
  ob_s2_subtitle: 'Podaj dane prawne i rejestracyjne swojej organizacji.',
  ob_s2_fullLegalName: 'Pełna nazwa prawna',
  ob_s2_fullLegalName_ph: 'Pełna nazwa podmiotu zgodnie z rejestrem',
  ob_s2_legalAddress: 'Adres prawny',
  ob_s2_legalAddress_ph: 'Zarejestrowany adres prawny',
  ob_s2_actualAddress: 'Adres faktyczny',
  ob_s2_actualAddress_ph: 'Fizyczny adres biura',
  ob_s2_registrationCountry: 'Kraj rejestracji',
  ob_s2_registrationCountry_ph: 'np. Ukraina',
  ob_s2_vatStatus: 'Status VAT',
  ob_s2_vatStatus_ph: 'Wybierz status VAT',
  ob_s2_vat_registered: 'Zarejestrowany',
  ob_s2_vat_not_registered: 'Niezarejestrowany',
  ob_s2_vat_exempt: 'Zwolniony',
  ob_s2_vatNumber: 'Numer VAT',
  ob_s2_vatNumber_ph: 'Numer identyfikacji VAT',
  ob_s2_directorName: 'Imię i nazwisko dyrektora',
  ob_s2_directorName_ph: 'Pełne imię i nazwisko dyrektora generalnego',
  ob_s2_authorizedPerson: 'Osoba upoważniona',
  ob_s2_authorizedPerson_ph: 'Imię i nazwisko osoby upoważnionej do podpisu',
  ob_s2_basisOfAuthority: 'Podstawa upoważnienia',
  ob_s2_basisOfAuthority_ph: 'Statut / Pełnomocnictwo / Zarządzenie',

  // Onboarding Step 3 — Primary Contact
  ob_s3_title: 'Główny kontakt',
  ob_s3_subtitle: 'Wskaż główną osobę kontaktową w swojej organizacji.',
  ob_s3_fullName: 'Imię i nazwisko',
  ob_s3_fullName_ph: 'np. Jan Kowalski',
  ob_s3_position: 'Stanowisko',
  ob_s3_position_ph: 'np. Dyrektor operacyjny',
  ob_s3_email: 'Email',
  ob_s3_email_ph: 'contact@company.com',
  ob_s3_phone: 'Telefon',
  ob_s3_phone_ph: '+48 500 123 456',
  ob_s3_contactType: 'Typ kontaktu',
  ob_s3_contactType_ph: 'Wybierz typ kontaktu',
  ob_s3_ct_technical: 'Techniczny',
  ob_s3_ct_legal: 'Prawny',
  ob_s3_ct_financial: 'Finansowy',
  ob_s3_ct_dispatch: 'Dyspozytorski',
  ob_s3_ct_commercial: 'Handlowy',
  ob_s3_ct_general: 'Ogólny',
  ob_s3_isPrimary: 'Ustaw jako główny kontakt',

  // Onboarding Step 4 — Bank Account
  ob_s4_title: 'Konto bankowe',
  ob_s4_subtitle: 'Podaj podstawowe dane bankowe do rozliczeń.',
  ob_s4_bankName: 'Nazwa banku',
  ob_s4_bankName_ph: 'np. PKO Bank Polski',
  ob_s4_iban: 'IBAN',
  ob_s4_iban_ph: 'PL61109010140000071219812874',
  ob_s4_currency: 'Waluta',
  ob_s4_currency_ph: 'PLN / EUR / USD',
  ob_s4_mfo: 'MFO / SWIFT',
  ob_s4_mfo_ph: 'Kod MFO lub SWIFT banku',
  ob_s4_accountHolder: 'Właściciel konta',
  ob_s4_accountHolder_ph: 'Nazwa prawna właściciela konta',
  ob_s4_isPrimary: 'Ustaw jako główne konto bankowe',

  // Onboarding Step 5 — Roles
  ob_s5_title: 'Role biznesowe',
  ob_s5_subtitle: 'Wybierz wszystkie role odpowiadające Twojej organizacji. Możesz wybrać kilka.',
  ob_s5_selected: 'Wybrane role',
  ob_s5_none: 'Nie wybrano ról',
  ob_s5_role_generator_owner: 'Właściciel generacji',
  ob_s5_role_generator_owner_desc: 'Posiada i eksploatuje aktywa energii odnawialnej',
  ob_s5_role_supplier: 'Dostawca',
  ob_s5_role_supplier_desc: 'Dostarcza energię elektryczną odbiorcom końcowym',
  ob_s5_role_trader: 'Trader',
  ob_s5_role_trader_desc: 'Kupuje i sprzedaje energię na rynkach hurtowych',
  ob_s5_role_consumer: 'Odbiorca',
  ob_s5_role_consumer_desc: 'Nabywa energię elektryczną na własne potrzeby',
  ob_s5_role_balancing_group_member: 'Uczestnik grupy bilansującej',
  ob_s5_role_balancing_group_member_desc: 'Uczestniczy w grupie bilansującej',
  ob_s5_role_bess_operator: 'Operator BESS',
  ob_s5_role_bess_operator_desc: 'Eksploatuje systemy magazynowania energii',
  ob_s5_role_service_provider: 'Dostawca usług',
  ob_s5_role_service_provider_desc: 'Świadczy usługi techniczne lub handlowe',

  // Login page
  login_welcome: 'Witamy',
  login_subtitle: 'Zaloguj się do swojego obszaru roboczego',
  login_label_login: 'Login',
  login_label_password: 'Hasło',
  login_btn: 'Zaloguj się →',
  login_checking: 'Sprawdzanie...',
  login_error_empty: 'Wprowadź login i hasło',
  login_error_wrong: 'Nieprawidłowy login lub hasło',
  login_error_rate: 'Zbyt wiele prób logowania. Spróbuj za {{sec}} s',
  login_error_unavailable: 'Serwer chwilowo niedostępny — spróbuj ponownie',
  login_forgot: 'Zapomniałeś hasła?',
  login_restore: 'Przywróć',
  login_new_company: 'Nowa firma?',
  login_demo: 'Zamów demo',

  // BESS page
  bess_title: 'Magazynowanie energii',
  bess_subtitle: 'Telemetria systemu magazynowania energii',
  bess_export: 'Eksport',
  bess_soc: 'Poziom naładowania (SOC)',
  bess_soh: 'Stan zdrowia (SOH)',
  bess_status: 'Status',
  bess_live: 'Na żywo',
  bess_stale: 'Nieaktualne',
  bess_discharge: 'Rozładowanie / Wyjście Aktywne',
  bess_charge: 'Dostępne do ładowania',
  bess_power: 'Moc aktywna',
  bess_power_flow: 'Kierunek mocy',
  bess_voltage: 'Napięcie baterii',
  bess_current: 'Prąd baterii',
  bess_bms: 'Status BMS',
  bess_pcs: 'Status PCS',
  bess_config: 'Konfiguracja',
  bess_nominal_capacity: 'Pojemność nominalna',
  bess_nominal_power: 'Moc nominalna',
  bess_visible_capacity: 'Widoczna pojemność użytkowa',
  bess_pcs_avail: 'Dostępność PCS',
  bess_updated: 'Zaktualizowano',
  bess_refresh: 'Odśwież',
  bess_no_telemetry: 'Telemetria BESS niedostępna',
  bess_retry: 'Spróbuj ponownie',
  bess_section_gauges: 'Wskaźniki pojemności',
  bess_section_battery: 'Stan baterii',
  bess_section_power: 'Moc i konfiguracja',
  bess_section_status: 'Status systemu',

  // UEEX market data
  nav_market: 'Rynek',
  nav_market_ueex: 'UEEX',
  nav_info_analytics: 'Analityka',
  nav_owner_home: 'Pulpit',
  nav_disp_home: 'Pulpit',
  nav_sec_dispatch: 'Dyspozytornia',
  nav_disp_fact: 'Fakt',
  nav_disp_scada: 'SCADA',
  nav_sec_finance: 'Finanse',
  nav_fin_cashflow: 'Cash Flow',
  nav_fin_pl: 'P&L',
  nav_fin_reports: 'Raporty',
  nav_gen: 'Generacja',
  nav_dispatch2: 'Dyspozycja',
  nav_incidents: 'Incydenty',
  nav_reports: 'Raportowanie',
  nav_sec_market: 'Rynek',
  nav_market_prices: 'Ceny',
  nav_gen_deviation: 'Odchylenie',
  nav_bess_state: 'Stan bieżący',
  nav_fin_income: 'Przychód',
  nav_fin_charges: 'Naliczenia',
  nav_fin_bess_arb: 'Arbitraż BESS',
  nav_an_news: 'Wiadomości',
  nav_notifications: 'Powiadomienia',
  nav_trade_schedule: 'Harmonogram handlu',
  nav_mms: 'Przekazanie do MMS',
  nav_forecast_mms: 'Prognoza/MMS',
  // Та сама сторінка в меню ArtemK називається «Диспетчерська». Ключ
  // лишився nav_optimization: перейменування самого ключа зачепило б
  // Sidebar, де зараз лежить незакомічена робота паралельної сесії.
  nav_optimization: 'Dyspozytornia',
  nav_fin_sale_terms: 'Warunki sprzedaży',
  nav_fin_result: 'Wynik finansowy',
  nav_disp_commands: 'Polecenia dyspozytora',
  nav_scada_monitoring: 'Monitoring urządzeń',
  nav_scada_telemetry: 'Telemetria',
  nav_scada_control: 'Sterowanie ręczne',
  nav_scada_events: 'Zdarzenia',
  nav_bess_charge: 'Ładowanie',
  nav_bess_discharge: 'Rozładowanie',
  nav_bess_arbitrage: 'Arbitraż',
  nav_assets_list: 'Lista elektrowni',
  nav_inc_faults: 'Awarie',
  nav_inc_limits: 'Ograniczenia',
  nav_inc_alarms: 'Alarmy',
  nav_rep_regulatory: 'Regulacyjne',
  nav_rep_management: 'Zarządcze',
  nav_rep_dispatch: 'Dyspozytorskie',
  nav_doc_contracts: 'Umowy',
  nav_doc_acts: 'Akty',
  nav_doc_correspondence: 'Korespondencja',
  nav_set_users: 'Użytkownicy',
  users_tenants: 'Najemca',
  users_no_tenants: 'Nie znaleziono najemców',
  users_select_tenant: 'Wybierz najemcę',
  users_select_tenant_hint: 'Wybierz najemcę w nagłówku, aby zobaczyć użytkowników',
  users_search: 'Szukaj po nazwie lub e-mail...',
  users_loading: 'Ładowanie użytkowników...',
  users_not_found: 'Nie znaleziono użytkowników',
  users_not_found_hint: 'Do tego najemcy nikt jeszcze nie został dodany',
  users_filter_hint: 'Spróbuj innego zapytania',
  users_col_user: 'Użytkownik',
  users_col_email: 'E-mail',
  users_col_role: 'Rola',
  users_col_added: 'Dodano',
  users_col_updated: 'Zaktualizowano',
  users_role_updated: 'Rola zaktualizowana',
  role_owner: 'Właściciel',
  role_admin: 'Administrator',
  role_editor: 'Redaktor',
  role_operator: 'Operator',
  role_finance: 'Finanse',
  role_viewer: 'Podgląd',
  nav_set_roles: 'Role',
  roles_permissions: 'uprawnień',
  roles_hierarchy: 'Hierarchia ról',
  roles_hierarchy_note: 'Role uporządkowane od najwyższych do najniższych uprawnień.',
  nav_set_integrations: 'Integracje',
  settings_tab_general: 'Ogólne',
  settings_tab_notifications: 'Powiadomienia',
  settings_tab_api: 'Dostęp API',
  settings_tab_security: 'Bezpieczeństwo',
  settings_language: 'Język interfejsu',
  settings_timezone: 'Strefa czasowa',
  settings_date_format: 'Format daty',
  settings_number_format: 'Format liczb',
  settings_api_base: 'Adres bazowy API',
  settings_api_online: 'Dostępne',
  settings_api_offline: 'Niedostępne',
  settings_api_checking: 'Sprawdzanie...',
  settings_api_test: 'Sprawdź połączenie z API',
  settings_api_key: 'Klucz API',
  settings_copy: 'Kopiuj',
  settings_webhook: 'Adres webhooka',
  settings_pass_current: 'Obecne hasło',
  settings_pass_new: 'Nowe hasło',
  settings_2fa: 'Uwierzytelnianie dwuskładnikowe',
  settings_2fa_desc: 'Włącz 2FA przez aplikację uwierzytelniającą',
  settings_2fa_enable: 'Włącz',
  settings_save: 'Zapisz ustawienia',
  settings_saving: 'Zapisywanie...',
  settings_notif_email_alerts: 'Powiadomienia e-mail',
  settings_notif_email_alerts_desc: 'Krytyczne alerty systemowe na e-mail',
  settings_notif_dispatch: 'Powiadomienia dyspozytorskie',
  settings_notif_dispatch_desc: 'Informacje o zmianach harmonogramu',
  settings_notif_forecast: 'Aktualizacje prognozy',
  settings_notif_forecast_desc: 'Codzienne podsumowanie prognozy e-mailem',
  settings_notif_market: 'Przegląd rynku',
  settings_notif_market_desc: 'Tygodniowe podsumowanie cen i trendów',
  settings_notif_contracts: 'Przypomnienia o umowach',
  settings_notif_contracts_desc: 'Alerty przed wygaśnięciem umowy',
  nav_sec_analytics: 'Analityka',
  nav_an_market: 'Rynek',
  ueex_page_title: 'Ukraińska Giełda Energii',
  ueex_page_subtitle: 'Ceny aukcyjne energii + Gwarancje pochodzenia (Solar GO)',
  ueex_page_window: 'Okres',
  ueex_page_days: 'dni',
  ueex_tab_electricity: 'Energia',
  ueex_tab_solar_go: 'Solar GO',
  ueex_tab_auctions: 'Aukcje',
  ueex_kpi_base_wavg: 'BASE cena średnioważona',
  ueex_kpi_block_wavg: 'Block cena średnioważona',
  ueex_kpi_premium: 'BASE premia',
  ueex_chart_price_title: 'Dynamika cen dziennych',
  ueex_chart_volume_title: 'Dzienne wolumeny',
  ueex_top_sellers_base: 'Top sprzedawcy BASE',
  ueex_no_data: 'Brak danych',
  ueex_seller: 'Sprzedawca',
  ueex_deals: 'Transakcje',
  ueex_wavg_price: 'Średnia cena',
  ueex_revenue: 'Przychód',
  ueex_solar_banner_title: 'Solar GO — rynek tylko po stronie podaży',
  ueex_solar_banner_text: 'Przez 90 dni sprzedano 0 MWh certyfikatów. Ceny ofertowe to baseline dla kontraktów B2B.',
  ueex_solar_avg_ask: 'Średnia cena ofertowa',
  ueex_solar_sell_positions: 'Pozycji sprzedaży',
  ueex_solar_closed_deals: 'Zamkniętych transakcji',
  ueex_solar_offered_volume: 'Wolumen oferowany',
  ueex_solar_chart_title: 'Solar GO ceny + wolumen',
  ueex_recent_auctions: 'Ostatnie aukcje',
  ueex_auc_num: 'Numer',
  ueex_auc_date: 'Data',
  ueex_auc_type: 'Typ',
  ueex_auc_state: 'Stan',
  ueex_auc_positions: 'Pozycje',
  ueex_auc_closed: 'Zamknięto',
  ueex_widget_title: 'UEEX — aktualne ceny',
  ueex_widget_view_all: 'Szczegóły',
  ueex_widget_loading: 'Ładowanie...',
  ueex_widget_base_label: 'BASE (24/7)',
  ueex_widget_block_label: 'Pozycja blokowa',
  ueex_widget_solar_label: 'Solar GO (ask)',
  ueex_widget_source: 'Źródło: epbets.ueex.com.ua',
  ueex_widget_subtitle: 'Dynamika cen w ostatnich dniach',
  ueex_widget_no_recent_data: 'Brak zamkniętych transakcji w ostatnim tygodniu',
  ueex_sections_title: 'Sekcje',
  ueex_section_electric_power: 'Energia',
  ueex_section_bilateral_contracts: 'Kontrakty dwustronne',
  ueex_section_solar_go: 'Solar GO',
  ueex_section_renewable_go: 'OZE GP porównanie',
  ueex_section_auctions: 'Wszystkie aukcje',
  ueex_external_link: 'Oficjalna strona UEEX',
  ueex_kpi_peak_wavg: 'PEAK średnia cena',
  ueex_chart_auctions_title: 'Wyniki aukcji sprzedaży energii',
  ueex_chart_auctions_subtitle: 'Średnia ważona cena dziennych transakcji, UAH/MWh bez VAT',
  ueex_source_note: 'Źródło',
  ueex_bilateral_title: 'Wyniki rynku kontraktów dwustronnych',
  ueex_bilateral_subtitle: 'Pozycje energetyczne',
  ueex_records: 'rekordów',
  ueex_renewable_title: 'Gwarancje pochodzenia OZE',
  ueex_renewable_subtitle: 'Porównanie Solar/Wind/Hydro/Bio',
  ueex_renewable_placeholder: 'Wykres będzie dodany w następnej iteracji',
  ueex_renewable_data_source: '(dane już zbierane)',
  ueex_all_auctions_title: 'Wszystkie aukcje',
  ueex_all_types: 'Wszystkie typy',
  ueex_loading: 'Ładowanie...',
  ueex_widget_days_suffix: 'd',
  ueex_widget_deals: 'transakcji',
  ueex_widget_positions: 'pozycji',
  ueex_widget_no_peak: 'Brak handlu PEAK',
  nav_sko: 'SKO',
  sko_page_title: 'System zarządzania ograniczeniami OZE',
  sko_page_subtitle: 'Grafiki PRS i zdarzenia curtailment Ukrenergo',
  sko_sections_title: 'Sekcje',
  sko_section_prs: 'Grafiki PRS',
  sko_section_curtailment: 'Zdarzenia curtailment',
  sko_section_about: 'O SKO',
  sko_external_link: 'Oficjalna strona Ukrenergo',
  sko_prs_banner_title: 'Faza A — Dry-run',
  sko_prs_banner_text: 'XML generowany z prognozy v0.2.2 i zapisywany do DB. Wysyłka SOAP — po podpisaniu umowy.',
  sko_prs_table_title: 'Wygenerowane PRS',
  sko_prs_col_date: 'Data dostawy',
  sko_prs_col_asset: 'Elektrownia',
  sko_prs_col_rev: 'Rew.',
  sko_prs_col_points: 'Punktów',
  sko_prs_col_energy: 'Energia',
  sko_prs_col_status: 'Status',
  sko_prs_preview: 'Podgląd',
  sko_prs_preview_title: 'Podgląd PRS XML',
  sko_close: 'Zamknij',
  sko_loading: 'Ładowanie...',
  sko_no_data: 'Brak danych',
  sko_curt_banner_title: 'Dziennik zdarzeń curtailment',
  sko_curt_banner_text: 'Loguj zdarzenia ograniczenia od dyspozytora OSP.',
  sko_curt_events_title: 'Zdarzenia curtailment',
  sko_curt_add_event: 'Dodaj zdarzenie',
  sko_curt_col_asset: 'Elektrownia',
  sko_curt_col_start: 'Start',
  sko_curt_col_end: 'Koniec',
  sko_curt_col_pct: 'Ograniczenie',
  sko_curt_col_reason: 'Powód',
  sko_curt_col_source: 'Źródło',
  sko_curt_col_dispatcher: 'Dyspozytor',
  sko_curt_active: 'W toku',
  sko_save: 'Zapisz',
  sko_saving: 'Zapisywanie...',
  sko_about_title: 'O Systemie',
  sko_about_p1: 'SKO — system Ukrenergo dla dwustronnej wymiany informacji z OZE.',
  sko_about_p2: 'Producenci wysyłają PRS — 15-min grafiki — przez SOAP.',
  sko_about_p3: 'Faza A — dry-run.',
  sko_about_phase_status: 'Status fazy:',
  sko_inbox_title: 'Skrzynka OSP',
  sko_inbox_subtitle: 'Komendy SKO (top-10)',
  sko_inbox_view_all: 'Wszystkie',
  sko_inbox_loading: 'Ładowanie...',
  sko_inbox_empty: 'Brak komend',
  sko_inbox_no_asset: '(ogólne)',
  sko_inbox_curtailment_to: 'Ograniczenie do',
  sko_inbox_ack_in: 'Potwierdź za',
  sko_inbox_min: 'min',
  sko_inbox_ack: 'Potwierdź',
  sko_inbox_details: 'Szczegóły',
  sko_bell_pending: 'Oczekujące',
  sko_bell_active: 'Aktywne',
  sko_bell_critical: 'Krytyczne',
  sko_bell_none: 'Brak komend',
  sko_section_inbox: 'Skrzynka komend',
  sko_inbox_full_title: 'Wszystkie komendy SKO',
  sko_inbox_filter_all: 'Wszystkie statusy',
  nav_trading: 'Trading',
  nav_trading_overview: 'Przegląd',
  nav_trading_dam: 'RDN',
  nav_trading_idm: 'RDB',
  trading_overview_title: 'Zbiorcza analityka rynku',
  trading_overview_subtitle: 'Spot OREE (DAM + IDM) vs pozagiełda UEEX vs faktyczna generacja naszych SES',
  trading_dam_title: 'Rynek dnia następnego',
  trading_dam_subtitle: 'OREE day-ahead — Zjednoczony System Energetyczny Ukrainy (OES)',
  trading_idm_title: 'Rynek dnia bieżącego',
  trading_idm_subtitle: 'OREE intraday — Zjednoczony System Energetyczny Ukrainy (OES)',
  oree_widget_title: 'Rynek energii OREE',
  oree_widget_subtitle: 'Ceny spot DAM + IDM, źródło: www.oree.com.ua',
  oree_widget_dam_today: 'Cena DAM dziś',
  oree_widget_idm_today: 'Cena IDM dziś',
  oree_widget_dam_7d: 'Średnia DAM 7 dni',
  oree_widget_idm_7d: 'Średnia IDM 7 dni',
  oree_widget_average_label: 'cena ważona',
  oree_widget_days_suffix: 'd',
  oree_dam_label: 'Rynek dnia następnego',
  oree_idm_label: 'Rynek dnia bieżącego',
  oree_volume_label: 'Wolumen obrotu',
  oree_potential_revenue_7d: 'Potencjalny przychód 7 dni',
  oree_potential_revenue_note: 'Ile zarobilibyśmy sprzedając faktyczną generację na DAM zamiast taryfy gwarantowanej',
  oree_tr_zone_label: 'Strefa handlowa',
  oree_daily_price_title: 'Dynamika dziennej ceny ważonej',
  oree_hourly_profile_title: 'Ceny i wolumeny godzinowe w dobie',
  oree_vs_ueex_title: 'Porównanie: spot (OREE) vs pozagiełda (UEEX BASE)',
  oree_vs_generation_title: 'Potencjalny przychód: nasza generacja × cena DAM (ostatnie 7 dni)',
  oree_vs_generation_note: 'Suma wszystkich naszych SES wg faktycznych danych inwerterów (modbus). Przychód = faktyczne MWh × godzinowa cena DAM.',
  common_loading: 'Ładowanie…',
  oree_kpi_price_unit_note: 'UAH/MWh · dobowa średnia ważona',
  oree_kpi_zone_value: 'UA OES',
  oree_kpi_zone_note: 'Zjednoczony System Energetyczny — sieć główna',
  oree_hourly_empty: 'OREE jeszcze nie opublikowało danych dla tej daty. Wybierz wcześniejszą datę.',
  oree_hourly_widget_title: 'DAM — godzinowe ceny i wolumeny w dobie',
  oree_hourly_widget_subtitle: 'OREE day-ahead spot, godzinowo',
  oree_hourly_kpi_wavg: 'Dobowa cena ważona',
  oree_hourly_kpi_peak: 'Cena szczytowa',
  oree_hourly_kpi_low: 'Cena minimalna',
  oree_hourly_kpi_total_vol: 'Łączny wolumen',
  curtailment_banner_title: 'Aktywne ograniczenie generacji',
  curtailment_banner_cap_label: 'Ograniczenie do',
  curtailment_banner_pct_suffix: 'mocy znamionowej',
  curtailment_banner_since: 'od',
  curtailment_banner_source: 'Źródło',
  curtailment_banner_source_auto: 'wykryto automatycznie',
  curtailment_banner_source_sko: 'polecenie SKO',
  curtailment_banner_source_analyst: 'rekonstrukcja analityka',
  curtailment_banner_view_sko: 'Szczegóły SKO',
  nav_osr: 'OSR',
  osr_page_title: 'Polecenia OSR (Operatora Systemu Dystrybucji)',
  osr_page_subtitle: 'Polecenia ograniczenia generacji od lokalnego OSD — NIE są kompensowane. W odróżnieniu od SKO od Укренерго.',
  osr_log_new: 'Zarejestruj polecenie',
  osr_cancel: 'Anuluj',
  osr_save: 'Zapisz',
  osr_saving: 'Zapisywanie…',
  osr_close_event: 'Zamknij',
  osr_status_active: 'Aktywne',
  osr_info_title: 'Dlaczego oddzielnie od SKO:',
  osr_info_body: 'OSR to polecenie lokalnego operatora, zwykle przekazywane telefonicznie lub e-mailem. W przeciwieństwie do SKO od Укренерго, NIE jest kompensowane. Prognoza DAM jest automatycznie ograniczana do limitu OSR.',
  osr_log_form_title: 'Nowe polecenie OSR',
  osr_field_asset: 'Aktywo',
  osr_field_started: 'Początek',
  osr_field_pct: '% mocy znamionowej',
  osr_field_pmax_kw: 'Limit w kW',
  osr_field_dispatcher: 'Dyspozytor',
  osr_field_org: 'Organizacja',
  osr_field_reason: 'Powód',
  osr_field_notes: 'Notatki',
  osr_select_asset: 'wybierz SES',
  osr_section_active: 'Aktywne polecenia',
  osr_section_past: 'Historia',
  osr_empty_active: 'Brak aktywnych poleceń OSR.',
  osr_empty_past: 'Brak historii.',
  osr_col_asset: 'SES',
  osr_col_started: 'Początek',
  osr_col_ended: 'Koniec',
  osr_col_limit: 'Ograniczenie',
  osr_col_dispatcher: 'Dyspozytor',
  osr_col_reason: 'Powód',
  curtailment_banner_title_osr: 'Aktywne ograniczenie OSR (bez kompensacji)',
  curtailment_banner_title_sko: 'Aktywne polecenie SKO (kompensowane przez Укренерго)',
  curtailment_banner_source_dispatcher_phone: 'telefon dyspozytora',
  curtailment_banner_source_dispatcher_email: 'e-mail dyspozytora',
  curtailment_banner_view_osr: 'Szczegóły OSR',
  greeting_night: 'Dobranoc',
  d_demo_data: 'dane demo (API niedostępne)',
  d_disp_console: 'Pulpit dyspozytora',
  d_ses_plural: 'elektrownie',
  d_u_uah: 'UAH',
  d_u_mwh: 'MWh',
  d_u_mw: 'MW',
  d_u_gwh: 'GWh',
  d_u_wm2: 'W/m²',
  d_kpi_month_rev: 'Przychód od początku miesiąca',
  d_kpi_guaranteed: 'gwarantowane (prognoza × RDN)',
  d_kpi_contract_rdn: 'kontrakt RDN −3%',
  d_kpi_today_rev: 'Przychód dziś',
  d_kpi_sold_da: 'sprzedane dzień wcześniej wg prognozy',
  d_kpi_tech_status: 'Stan techniczny',
  d_kpi_generating: 'generuje',
  d_kpi_current_status: 'bieżący stan elektrowni',
  d_kpi_updates_auto: 'aktualizuje się automatycznie',
  d_kpi_forecast_today: 'Prognoza na dziś',
  d_kpi_expected_gen: 'oczekiwana produkcja dzienna',
  d_kpi_fact_now: 'fakt teraz',
  d_dkpi_cur_gen: 'Bieżąca generacja',
  d_dkpi_total_power_now: 'łączna moc teraz',
  d_dkpi_modbus_src: 'wg danych Modbus / SCADA',
  d_dkpi_model_weather: 'model v0.2.2 · prognoza pogody',
  d_dkpi_fulfilment: 'Realizacja prognozy',
  d_dkpi_fact_fc_avg: 'fakt / prognoza teraz (śr.)',
  d_dkpi_portfolio_eff: 'efektywność portfela',
  d_map_title: 'Mapa elektrowni',
  d_map_weather: 'Pogoda',
  d_map_no_telemetry: 'brak telemetrii',
  d_map_today_fact: 'Dziś (fakt)',
  d_map_forecast: 'Prognoza',
  d_map_revenue_guar: 'Przychód (gwar.)',
  d_map_insolation: 'Nasłonecznienie',
  d_map_cloud: 'zachmurzenia',
  d_btn_details: 'Szczegóły',
  d_rev_title: 'Przychód: plan vs fakt',
  d_rev_subtitle: 'szacowany (prognoza × RDN) vs faktyczny · przychód',
  d_p_today: 'Dziś',
  d_p_10d: '10 dni',
  d_p_month: 'Miesiąc',
  d_p_quarter: 'Kwartał',
  d_p_year: 'Rok',
  d_rev_estimated: 'Szacowany',
  d_rev_actual: 'Faktyczny',
  d_rev_losses: 'Straty',
  d_rev_plan_fulfil: 'Realizacja planu',
  d_chart_loading: 'Ładowanie…',
  d_chart_no_data: 'Brak danych za okres',
  d_plan: 'Plan',
  d_fact: 'Fakt',
  d_plan_forecast: 'Plan (prognoza)',
  d_gen_title: 'Generacja: plan vs fakt',
  d_gen_subtitle: 'prognoza vs faktyczna produkcja · MWh',
  d_gen_shortfall: 'Niedobór',
  d_gen_fulfil: 'Realizacja',
  d_port_title: 'Elektrownie portfela',
  d_port_fc_eff: 'ef. prognozy',
  d_port_rev_day: 'przychód/dzień',
  d_port_gen_today: 'wyprodukowano dziś',
  d_port_not_launched: 'Nie uruchomiono',
  d_port_fc_now: 'realizacja prognozy teraz',
  d_port_guar_rev_today: 'Gwar. przychód dziś',
  d_port_installed: 'zainstalowano',
  d_port_open: 'Otwórz stronę',
  d_ops_incidents: 'Incydenty',
  d_ops_active: 'aktywnych',
  d_ops_no_incidents: 'Brak aktywnych incydentów',
  d_ops_lost_value: 'Utracony przychód',
  d_ops_lost_sub: 'utracony przychód · szacunek dziś',
  d_ops_by_cause: 'Wg przyczyny',
  d_ops_no_losses: 'Brak strat',
  d_ops_uah_day: 'UAH / dzień',
  d_cause_outage: 'Wyłączenie',
  d_cause_curtail: 'Ograniczenie OSD',
  d_ops_resolved: 'usunięto',
  d_ops_since: 'od',
  d_ops_days: 'dni',
  d_inv_title: 'Stan falowników',
  d_inv_sub: 'szacunek wg mocy fakt. vs oczek. · aktualizacja w dzień',
  d_inv_working_portfolio: 'Działa (portfel)',
  d_inv_no_data: 'Brak danych',
  d_inv_st_pending: 'Oczekuje uruchomienia',
  d_inv_all: 'Wszystkie',
  d_inv_inv_working: 'falowników działa',
  d_inv_works: 'działa',
  d_inv_questionable: 'pod znakiem zapytania',
  d_inv_offline: 'offline',
  d_inv_night: 'Szacunek niedostępny w nocy',
  d_inv_no_tele: 'Brak telemetrii falowników',
  d_inv_abbr: 'fal.',
  d_inv_at: 'o',
  d_inv_footer: 'ℹ️ Brak telemetrii poszczegolnych falownikow na stacjach SMA (Nikopol, Nikelios) — stan szacowany z mocy lacznej. W nocy i bez slonca szacunek niedostepny (to norma, nie awaria).',
  d_sec_imbalance: 'Niebilans w miesiącu',
  d_sec_imbalance_sub: 'orientacyjnie · cena niebilansu wg aktów 14–15',
  d_sec_bess: 'Arbitraż BESS',
  d_sec_bess_sub: 'ładowanie w tanich godzinach / rozładowanie w drogich · dane w przygotowaniu',
  d_sec_settlements_with: 'Rozliczenia z',
  d_sec_offtaker: 'odbiorca',
  d_sec_receivables: 'Należności',
  d_sec_payment_due: 'płatność do',
  d_sec_reports: 'Raporty',
  d_bc_home: 'Główna',
  d_bc_dispatch: 'Dyspozytornia',
  d_bc_forecast: 'Prognoza',
  d_bc_analytics: 'Analityka',
  d_bc_market: 'Rynek',
  d_bc_info: 'Wiadomości',
  d_bc_assets: 'Aktywa',

  // Telemetria falowników (karta aktywa → zakładka Overview).
  inv_tel_title: 'Telemetria falowników',
  inv_tel_subtitle: 'Bieżące dane Modbus · interwał 30 min',
  inv_tel_updated: 'Zaktualizowano',
  inv_tel_refresh: 'Odśwież teraz',
  inv_tel_error: 'Nie udało się wczytać telemetrii falowników',
  inv_tel_retry: 'Spróbuj ponownie',
  inv_tel_pending: 'Telemetria Modbus nie jest jeszcze skonfigurowana',
  inv_tel_total: 'Łączna moc AC',
  inv_tel_forecast: 'Prognoza',
  inv_tel_no_forecast: 'Brak prognozy',
  inv_tel_delta: 'Odchylenie od prognozy',
  inv_tel_inverters: 'Falowniki',
  inv_tel_coverage: 'Pokrycie',
  inv_tel_quality: 'Jakość danych',
  inv_tel_last_update: 'Ostatnia aktualizacja',
  inv_tel_cap: 'Ograniczenie mocy',
  inv_tel_curtailed: 'Ograniczono do {{pct}}%',
  inv_tel_groups: 'Grupy falowników',
  inv_tel_units_count: '{{count}} szt. łącznie',
  inv_tel_unit: 'Falownik',
  inv_tel_power: 'Moc',
  inv_tel_pct_nominal: '% nominalnej',
  inv_tel_in_operation: 'Falowniki w pracy',
  inv_tel_state_generating: 'Generuje',
  inv_tel_state_standby: 'Oczekiwanie',
  inv_tel_state_no_power: 'Brak generacji',

  // Karta aktywa (/assets/:id): nagłówki sekcji, etykiety pól, zakładki.
  asset_tab_overview: 'Przegląd',
  asset_tab_technical: 'Specyfikacja techniczna',
  asset_tab_market: 'Konfiguracja rynku',
  asset_tab_metering: 'Pomiary / SCADA',
  asset_tab_forecasting: 'Prognozowanie',
  asset_tab_financial: 'Warunki finansowe',
  asset_tab_contracts: 'Umowy',
  asset_tab_documents: 'Dokumenty',
  asset_sec_general: 'Informacje ogólne',
  asset_sec_location: 'Lokalizacja',
  asset_sec_progress: 'Postęp specyfikacji',
  asset_f_name: 'Nazwa',
  asset_f_type: 'Typ',
  asset_f_region: 'Region',
  asset_f_address: 'Adres',
  asset_f_coordinates: 'Współrzędne',
  asset_f_commissioned: 'Oddano do eksploatacji',
  asset_f_capacity: 'Moc',
  asset_f_status: 'Status',
  asset_f_number: 'Numer',
  asset_f_period: 'Okres',
  asset_not_found: 'Nie znaleziono aktywa',
  asset_no_documents: 'Brak wgranych dokumentów',
  asset_load_failed: 'Nie udało się wczytać aktywu',
  asset_wizard_title: 'Kreator konfiguracji aktywu',
  asset_wizard_exit: 'Wyjdź z kreatora',
  asset_wizard_prev: 'Wstecz',
  asset_wizard_next: 'Dalej',
  asset_wizard_done: 'Zakończ konfigurację',
  asset_back_to_list: 'Do listy aktywów',
  asset_no_contracts: 'Do tego aktywu nie przypisano umów',
  asset_back: 'Wszystkie aktywa',
  asset_section: 'Aktyw',
  common_done: 'Wykonano',
  common_pending: 'Oczekuje',
  common_active: 'Aktywny',
  common_saved: 'Zapisano',
  common_save_failed: 'Nie udało się zapisać',

  // Вкладки картки активу: технічна специфікація, ринок, облік,
  // прогнозування, фінанси. Технічні назви (SCADA, Modbus, AC/DC, DAM)
  // навмисно лишаються без перекладу.
  at_installed_ac: 'Moc zainstalowana AC',
  at_installed_dc: 'Moc zainstalowana DC',
  at_dc_ac_ratio: 'Stosunek DC / AC',
  at_panel_type: 'Typ modułów',
  at_panel_count: 'Liczba modułów',
  at_panel_power: 'Moc nominalna modułu',
  at_tilt: 'Kąt nachylenia',
  at_azimuth: 'Azymut',
  at_inverter_type: 'Typ falowników',
  at_inverter_count: 'Liczba falowników',
  at_inverter_power: 'Łączna moc falowników',
  at_battery_cap: 'Pojemność magazynu',
  at_grid_voltage: 'Napięcie przyłączenia',
  at_metering_code: 'Kod punktu pomiarowego',
  at_scada_vendor: 'Dostawca SCADA',
  at_comm_protocol: 'Protokół komunikacji',
  at_refresh: 'Interwał odświeżania danych',
  at_save_failed: 'Nie udało się zapisać specyfikacji',
  am_title: 'Konfiguracja rynku',
  am_model: 'Model rynku',
  am_model_ph: 'Wybierz model rynku...',
  am_zone: 'Strefa handlowa',
  am_balancing: 'Grupa bilansująca',
  am_irp: 'Strona odpowiedzialna za niezbilansowanie',
  am_settlement: 'Model rozliczeń',
  ame_title: 'Integracje pomiarów / SCADA',
  ame_sub: 'Punkty zbierania danych i protokoły',
  ame_new: 'Nowa integracja',
  ame_add: 'Dodaj integrację',
  ame_adding: 'Dodawanie…',
  ame_empty: 'Brak skonfigurowanych integracji',
  ame_empty_hint: 'Dodaj źródło danych: SCADA, API lub inne',
  ame_protocol: 'Protokół',
  ame_auth: 'Typ uwierzytelniania',
  af_title: 'Konfiguracje prognozowania',
  af_new: 'Nowa konfiguracja',
  af_empty: 'Brak konfiguracji prognozowania',
  af_empty_hint: 'Dodaj dostawcę prognozy, aby włączyć prognozowanie generacji',
  af_generation: 'Generowanie prognozy',
  am_model_feed_in: 'Taryfa gwarantowana',
  am_model_ppa: 'PPA (umowa zakupu energii)',
  am_model_trading: 'Handel na rynku',
  am_model_self: 'Autokonsumpcja',
  am_model_hybrid: 'Hybrydowa',
  am_desc_feed_in: 'Stała taryfa płacona przez operatora sieci za całą wytworzoną energię.',
  am_desc_ppa: 'Długoterminowa umowa sprzedaży energii odbiorcy po cenie stałej lub indeksowanej.',
  am_desc_trading: 'Energia sprzedawana na rynku dnia następnego lub dnia bieżącego po cenach spot.',
  am_desc_self: 'Wytworzona energia zużywana na obiekcie, nadwyżka może być eksportowana.',
  am_desc_hybrid: 'Połączenie kilku modeli rynkowych.',
  am_saved_ok: 'Zapisano konfigurację rynku',
  am_save_failed: 'Nie udało się zapisać konfiguracji rynku',
  ame_type_manual: 'Ręczne wgranie',
  ame_required: 'Wymagany typ integracji i URL punktu końcowego',
  ame_added_ok: 'Dodano integrację pomiarów',
  ame_add_failed: 'Nie udało się dodać integracji',
  ame_type_label: 'Typ integracji',
  ame_endpoint: 'URL punktu końcowego',
  ame_secret_ref: 'Odwołanie do sekretu',
  ame_secret_hint: '(ścieżka w vault, nie sam klucz)',
  ame_secret_warn: 'Przechowuj tylko ścieżkę odwołania. Nigdy nie wklejaj tu prawdziwych kluczy API.',
  af_type_day_ahead: 'Dzień następny',
  af_type_intraday: 'Dzień bieżący',
  af_type_real_time: 'Czas rzeczywisty',
  af_type_monthly: 'Miesięczny',
  af_required: 'Wymagany dostawca i typ prognozy',
  af_added_ok: 'Dodano konfigurację prognozowania',
  af_add_failed: 'Nie udało się dodać konfiguracji prognozowania',
  af_provider: 'Dostawca prognozy',
  af_type: 'Typ prognozy',
  afi_model_fixed: 'Cena stała',
  afi_model_indexed: 'Indeksowana do rynku',
  afi_model_formula: 'Według formuły',
  afi_model_feed_in: 'Taryfa gwarantowana',
  afi_model_custom: 'Inna',
  afi_required: 'Wymagana waluta i model cenowy',
  afi_added_ok: 'Dodano warunki finansowe',
  afi_add_failed: 'Nie udało się dodać warunków finansowych',
  afi_currency: 'Waluta',
  afi_model: 'Model cenowy',
  afi_formula: 'Formuła ceny',
  afi_formula_hint: '(dla cen według formuły)',
  afi_cur_uah: 'UAH — hrywna',
  afi_cur_eur: 'EUR — euro',
  afi_cur_usd: 'USD — dolar amerykański',
  afi_cur_pln: 'PLN — złoty',

  af_tab_configs: 'Konfiguracje',
  af_horizon: 'Horyzont prognozy',
  af_frequency: 'Częstotliwość aktualizacji',
  af_responsible: 'Strona odpowiedzialna',
  afi_title: 'Warunki finansowe',
  afi_new: 'Nowe warunki finansowe',
  afi_empty: 'Nie określono warunków finansowych',
  afi_empty_hint: 'Dodaj model cenowy i warunki płatności',
  afi_payment: 'Warunki płatności',
  afi_period: 'Okres rozliczeniowy',
  common_select_type: 'Wybierz typ...',
  common_select_model: 'Wybierz model...',

  // Прогнозні віджети активу, групи обладнання, налаштування.
  fw_daily_title: 'Prognoza godzinowa na dobę',
  fw_summary_title: 'Podsumowanie prognozy generacji',
  fw_today: 'Dziś',
  fw_forecast: 'Prognoza',
  fw_actual: 'Rzeczywiste',
  fw_accuracy: 'Dokładność',
  fw_date: 'Data',
  fw_humidity: 'Wilgotność',
  fw_cloud: 'Zachmurzenie',
  fw_avg_cloud: 'Średnie zachmurzenie',
  fw_direct: 'Bezpośrednie',
  fw_diffuse: 'Rozproszone',
  fw_max_hourly: 'Maksimum godzinowe',
  fw_max_shortwave: 'Maksimum promieniowania',
  fw_total_forecast: 'Razem wg prognozy',
  fw_window: 'Okno prognozy',
  fw_load_failed: 'Nie udało się wczytać prognozy',
  fw_load_failed_daily: 'Nie udało się wczytać prognozy dobowej',
  fw_excellent: 'Doskonała',
  fw_good: 'Dobra',
  fw_fair: 'Zadowalająca',
  fw_poor: 'Niska',
  eq_inverter_groups: 'Grupy falowników',
  eq_panel_groups: 'Grupy modułów',
  eq_add_panel: 'Dodaj grupę modułów',
  eq_add_inverter: 'Dodaj grupę falowników',
  eq_edit_panel: 'Edytuj grupę modułów',
  eq_edit_inverter: 'Edytuj grupę falowników',
  eq_save_add_another: 'Zapisz i dodaj kolejną',
  eq_delete_confirm: 'Usunąć „{{name}}”? Tej operacji nie można cofnąć.',
  eq_equipment: 'Sprzęt',
  eq_load_failed: 'Nie udało się wczytać grup sprzętu',
  eq_panel_sub: 'Modele modułów fotowoltaicznych na tym obiekcie (informacyjnie, nieużywane we wzorze prognozy)',
  eq_inverter_sub: 'Sektory falowników i ich konfiguracja Modbus (kolektory odpytują je co 5 min)',
  eq_power_w: 'Moc, W',
  eq_power_kw: 'Moc, kW',
  eq_not_configured: 'nieskonfigurowane',
  eq_modbus_section: 'Połączenie Modbus (opcjonalnie)',
  eq_notes: 'Notatki',
  eq_technology: 'Technologia',
  eq_nominal_power_w: 'Moc nominalna, W',
  eq_nominal_power_kw: 'Moc nominalna, kW',
  eq_panel_count: 'Liczba modułów',
  eq_inverter_count: 'Liczba falowników',
  eq_protocol: 'Protokół',
  eq_host: 'Host',
  eq_port: 'Port',
  eq_unit_id_plant: 'unit_id agregatu elektrowni',
  eq_unit_ids_csv: 'unit_id dla falowników (CSV)',
  eq_ph_optional: 'opcjonalnie',
  eq_ph_unit_id: 'dla SMA: 2; puste — odpytywanie per falownik',
  eq_ph_notes: 'dowolne notatki operatora',
  eq_manufacturer: 'Producent',
  eq_model: 'Model',
  eq_count: 'Liczba',
  common_save: 'Zapisz',
  common_edit: 'Edytuj',
  common_added: 'Dodano',
  common_deleted: 'Usunięto',
  common_delete_failed: 'Nie udało się usunąć',
  common_online: 'Online',
  common_offline: 'Offline',
  set_general: 'Ogólne',
  set_notifications: 'Powiadomienia',
  set_api_access: 'Dostęp do API',
  set_api_online: 'API działa i odpowiada',
  set_api_unreachable: 'API niedostępne',
  set_api_copied: 'Klucz API skopiowany',
  set_email_alerts: 'Powiadomienia e-mail',
  set_forecast_updates: 'Aktualizacje prognozy',
  set_dispatch_notif: 'Powiadomienia dyspozytorskie',
  set_contract_remind: 'Przypomnienia o umowach',
  set_market_digest: 'Przegląd rynku',
  set_daily_summary: 'Codzienne e-maile z podsumowaniem prognozy',

  // Адміністрування, контрагенти, створення активу.
  adm_section: 'Administracja',
  adm_tenants: 'Najemcy',
  adm_tenant_users: 'Użytkownicy najemcy',
  adm_manage_tenants: 'Zarządzanie najemcami platformy',
  adm_select_tenant: 'Wybierz najemcę',
  adm_no_tenants: 'Brak najemców',
  adm_no_tenants_found: 'Nie znaleziono najemców',
  adm_no_users: 'Nie znaleziono użytkowników',
  adm_try_search: 'Spróbuj innego zapytania',
  adm_tenant_id: 'ID najemcy',
  adm_tenant_not_found: 'Nie znaleziono najemcy',
  adm_add_user: 'Dodaj użytkownika',
  adm_user_added: 'Dodano użytkownika',
  adm_role_updated: 'Zaktualizowano rolę',
  adm_err_tenants: 'Nie udało się wczytać najemców',
  adm_err_tenant: 'Nie udało się wczytać najemcy',
  adm_err_users: 'Nie udało się wczytać użytkowników',
  adm_err_role: 'Nie udało się zaktualizować roli',
  adm_err_add_user: 'Nie udało się dodać użytkownika',
  common_user: 'Użytkownik',
  common_email: 'Email',
  common_role: 'Rola',
  common_name: 'Nazwa',
  common_slug: 'Slug',
  common_status: 'Status',
  common_created: 'Utworzono',
  common_updated: 'Zaktualizowano',
  common_added2: 'Dodano',
  common_cancel: 'Anuluj',
  common_add: 'Dodaj',
  common_saving: 'Zapisywanie…',
  common_overview: 'Przegląd',
  common_not_found: 'Nie znaleziono',
  common_users: 'Użytkownicy',
  cp_section: 'Kontrahenci',
  cp_legal_profile: 'Dane prawne',
  cp_contacts: 'Kontakty',
  cp_bank_accounts: 'Rachunki bankowe',
  cp_full_name: 'Pełna nazwa',
  cp_country: 'Kraj',
  cp_add_asset: 'Dodaj aktyw',
  cp_add_contract: 'Dodaj umowę',
  cp_err_load: 'Nie udało się wczytać kontrahenta',
  ac_basic_info: 'Dane podstawowe',
  ac_commissioning: 'Oddanie do eksploatacji',
  ac_decommissioned: 'Wycofany z eksploatacji',
  ac_consumer_site: 'Obiekt poboru',
  ac_err_create: 'Nie udało się utworzyć aktywa',
  ac_err_name: 'Podaj nazwę aktywa',
  ac_err_address: 'Podaj adres',
  ac_err_capacity: 'Podaj moc',
  ac_err_eic: 'Podaj kod EIC',
  ac_err_cp_id: 'Brak identyfikatora kontrahenta',

  // Платформне адміністрування.
  pf_section: 'Administracja platformy',
  pf_assets_overview: 'Przegląd aktywów',
  pf_cp_overview: 'Przegląd kontrahentów',
  pf_tenants_overview: 'Przegląd najemców',
  pf_users_overview: 'Przegląd użytkowników',
  pf_dashboard: 'Pulpit',
  pf_no_assets: 'Brak aktywów w systemie',
  pf_no_cp: 'Nie znaleziono kontrahentów',
  pf_no_tenant_users: 'Brak użytkowników w tym najemcy',
  pf_err_assets: 'Nie udało się wczytać aktywów',
  pf_err_cp: 'Nie udało się wczytać kontrahentów',
  pf_err_tenant_users: 'Nie udało się wczytać użytkowników najemcy',
  pf_err_stats: 'Nie udało się wczytać statystyk',
  pf_invalid_response: 'Nieprawidłowa odpowiedź',
  pf_active_assets: 'Aktywne aktywa',
  pf_total_tenants: 'Łącznie najemców',
  pf_system_admins: 'Administratorzy systemu',
  pf_onboard_done: 'Zakończone wdrożenia',
  pf_onboard_wip: 'Wdrożenia w toku',
  pf_draft_cp: 'Szkice kontrahentów',
  pf_asset: 'Aktyw',
  pf_counterparty: 'Kontrahent',
  pf_cp_id: 'ID kontrahenta',
  pf_tenant: 'Najemca',
  pf_auth_id: 'ID uwierzytelnienia',
  pf_docs: 'Dokumenty',
  pf_onboarding: 'Wdrożenie',
  pf_director: 'Dyrektor',
  pf_full_legal: 'Pełna nazwa prawna',
  pf_legal_address: 'Adres prawny',
  pf_grid_voltage: 'Napięcie przyłączenia',
  pf_balancing: 'Grupa bilansująca',
  pf_forecast_cfg: 'Konfiguracje prognoz',
  common_assets: 'Aktywa',
  common_contracts: 'Umowy',
  common_documents: 'Dokumenty',
  common_coordinates: 'Współrzędne',

  at_title: 'Specyfikacja techniczna',
  at_saved_ok: 'Zapisano specyfikację techniczną',
  at_sub: 'Falowniki, moduły, SCADA i konfiguracja pomiarów',
  at_scada_available: 'SCADA dostępna',
  at_scada_hint: 'Włącz, jeśli ten aktyw ma podłączony system SCADA',
  at_unit_ratio: 'wsp.',
  common_eg: 'np.',
  at_fc_params_title: 'Techniczne parametry prognozowania',
  at_fc_params_sub: 'Te parametry są wymagane do prognozy generacji słonecznej',
  af_sub: 'Dostawcy prognoz ML i harmonogramy aktualizacji',
  common_delete: 'Usuń',
};

export default translations;
